import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, PropsWithChildren, useContext, useEffect, useState } from 'react';
import { useStore } from 'react-redux';
import { IndexedDbKeyValueStorageStrategy } from 'record-it-utils/dataStorage/KeyValueStorageStrategy/IndexedDbKeyValueStorageStrategy';
import { config } from '../config';
import { PageLoadingOverlayContext } from '../context/PageLoadingOverlayContext';
import { initI18n } from '../setup/initI18n';
import { initKeyValueStorage } from '../setup/initKeyValueStorage';
import { initStorageAdapter } from '../setup/initStorageAdapter';
import { resetState } from '../store/action/resetState';
import { storeName } from '../store/store';
import { StoreUtils } from '../store/utils/StoreUtils';
export const AppBaseSetup: FunctionComponent<PropsWithChildren> = React.memo(props => {
  const $ = _c(7);
  const {
    children
  } = props;
  const {
    startLoading,
    addLoadingMessage
  } = useContext(PageLoadingOverlayContext);
  const [initialized, setInitialized] = useState(false);
  const store = useStore();
  let t0;
  let t1;
  if ($[0] !== addLoadingMessage || $[1] !== startLoading || $[2] !== store) {
    t0 = () => {
      const loadingDisposable = startLoading();
      (async () => {
        addLoadingMessage("loading configuration");
        await config.load();
        addLoadingMessage("initializing i18n");
        await initI18n();
        addLoadingMessage("initializing KeyValueStorage");
        await initKeyValueStorage(new IndexedDbKeyValueStorageStrategy());
        addLoadingMessage("initializing StorageAdapter");
        initStorageAdapter();
        addLoadingMessage("loading state");
        const state = await StoreUtils.loadState(storeName);
        if (state) {
          store.dispatch(resetState(state));
        }
        setInitialized(true);
        loadingDisposable.dispose();
      })();
      return () => {
        setInitialized(false);
        loadingDisposable.dispose();
      };
    };
    t1 = [startLoading, addLoadingMessage, store];
    $[0] = addLoadingMessage;
    $[1] = startLoading;
    $[2] = store;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  if (!initialized) {
    return null;
  }
  let t2;
  if ($[5] !== children) {
    t2 = <>{children}</>;
    $[5] = children;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
});